import React from "react";
import { Flex } from "@chakra-ui/layout";
import { roboCobrancaVariaveis } from "./../../../util/roboCobrancaVariaveis";
import OutlineButton from "ui/components/Button/OutlineButton";

interface TagsVariaveisTemplateProps {
  onClickVariavel: (value: string) => any;
}

function TagsVariaveisTemplate({
  onClickVariavel,
}: TagsVariaveisTemplateProps) {
  return (
    <Flex gap={"8px 10px"} flexWrap="wrap">
      {Object.values(roboCobrancaVariaveis).map(({ label, value }) => (
        <OutlineButton
          key={value}
          onClick={() => {
            onClickVariavel(value);
          }}
          rounded={50}
          height={"32px"}
        >
          {value}
        </OutlineButton>
      ))}
    </Flex>
  );
}

export default TagsVariaveisTemplate;
